import { IView } from "../models/requests/IUserRoleView";

export const findUpdateCommand = (command: string, updateCommands: IView | undefined) => {
    return updateCommands?.fields?.find((f) => f.name === command);
};
